import IconButton from 'material-ui/IconButton/IconButton';
export { IconButtonProps as IIconButtonProps } from 'material-ui/IconButton/IconButton';

export default IconButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/IconButton/index.ts